"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _notistack = require("notistack");

var _SnackbarCloseButton = _interopRequireDefault(require("./SnackbarCloseButton"));

var colors = _interopRequireWildcard(require("./theme/colors"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(theme) {
  return {
    success: {
      backgroundColor: colors.GREEN
    },
    error: {
      backgroundColor: theme.palette.error.main
    },
    warning: {
      backgroundColor: colors.ORANGE
    },
    info: {
      backgroundColor: colors.BLUE
    }
  };
};

var CncSnackbarProvider = function CncSnackbarProvider(_ref) {
  var classes = _ref.classes,
      children = _ref.children;
  return _react.default.createElement(_notistack.SnackbarProvider, {
    action: function action(snackbarKey) {
      return _react.default.createElement(_SnackbarCloseButton.default, {
        snackbarKey: snackbarKey
      });
    },
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    autoHideDuration: 5000,
    classes: {
      variantSuccess: classes.success,
      variantError: classes.error,
      variantWarning: classes.warning,
      variantInfo: classes.info
    }
  }, children);
};

var _default = (0, _styles.withStyles)(styles)(CncSnackbarProvider);

exports.default = _default;